"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.percentFormatter = exports.compactDateFormatter = exports.dateFormatter = exports.compactNumberFormatter = exports.numberFormatter = void 0;
var inferDate = function (value) {
    return value instanceof Date ? value : new Date(value);
};
/**
 * The number formatter for charts.
 *
 * @remarks
 * Used by default as tooltip formatter.
 *
 * @param locales - The locale or multiple locales to use in formatting.
 * @param options - Options for overriding the default options for number formatting.
 * @returns By default the number as a string with a maximum of two decimal places. e.g. 15, 15.1, or 15.43
 */
var numberFormatter = function (locales, options) {
    return function (value) {
        return value.toLocaleString(locales, options !== null && options !== void 0 ? options : { maximumFractionDigits: 2 });
    };
};
exports.numberFormatter = numberFormatter;
/**
 * The compact number formatter for charts.
 *
 * @remarks
 * Used by default as Y axis tick formatter.
 *
 * @param locales - The locale or multiple locales to use in formatting.
 * @returns By default the number as a compact string. e.g. 1.5K
 */
var compactNumberFormatter = function (locales) {
    var baseOptions = {
        style: "decimal",
        useGrouping: true,
    };
    try {
        var formatter = (0, exports.numberFormatter)(locales, __assign(__assign({}, baseOptions), { notation: "compact" }));
        // This is a temporary fix for an issue with `notation: "compact"` on Safari 14.1 on macOS Mojave.
        // Calling the formatter in such environment throws an error, which is caught and a fallback formatter is provided
        // Since this is a curried function, this test will only be performed once.
        // TODO: evaluate the need for this fix in september 2021.
        formatter(1);
        return formatter;
    }
    catch (_a) {
        // Fallback formatter for the issue above. Returns the full number.
        return (0, exports.numberFormatter)(locales, baseOptions);
    }
};
exports.compactNumberFormatter = compactNumberFormatter;
/**
 * The date formatter for charts.
 *
 * @remarks
 * Used by default as tooltip label formatter.
 *
 * @param locales - The locale or multiple locales to use in formatting.
 * @param options - Options for overriding the default options for date formatting.
 * @returns By default the date as a long string. e.g. January 15, 2021, 12:12
 */
var dateFormatter = function (locales, options) {
    var formatter = new Intl.DateTimeFormat(locales, options !== null && options !== void 0 ? options : {
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        hour12: false,
        minute: "numeric",
    });
    return function (value) {
        var date = inferDate(value);
        return formatter.format(date);
    };
};
exports.dateFormatter = dateFormatter;
/**
 * The compact date formatter for charts.
 *
 * @remarks
 * Used by default as X axis tick formatter.
 *
 * @param locales - The locale or multiple locales to use in formatting.
 * @returns The date as a short string (MM/dd/yy). e.g. 01/27/21
 */
var compactDateFormatter = function (locales) {
    return (0, exports.dateFormatter)(locales, {
        month: "2-digit",
        day: "2-digit",
        year: "2-digit",
    });
};
exports.compactDateFormatter = compactDateFormatter;
/**
 * Formatter that converts number to percentage.
 *
 * @param value - number to be converted.
 * @returns percentage value. e.g. 15%
 */
var percentFormatter = function (value) {
    return value.toLocaleString(undefined, { style: "percent" });
};
exports.percentFormatter = percentFormatter;
//# sourceMappingURL=formatters.js.map